import { action, extendObservable } from 'mobx';
import FetchService from '../../../../core/services/FetchService';

class ContentCourseDetailService {
  fetchCourse = new FetchService();
  fetchModule = new FetchService();
  fetchUnit = new FetchService();
  fetchMasteryTest = new FetchService();

  constructor() {
    extendObservable(this, {
      course: null,
      module: null,
      unit: null,
      masteryTest: null,
    });
  }

  handleLoadCourse = action((id) => {
    this.fetchCourse
      .fetch({
        url: `/courses/${id}`,
      })
      .then(() => {
        if (this.fetchCourse.data) {
          this.course = this.fetchCourse.data;
        } else {
          this.course = null;
        }
      });
  });

  handleLoadModule = action((id) => {
    this.fetchModule
      .fetch({
        url: `/modules/${id}`,
      })
      .then(() => {
        if (this.fetchModule.data) {
          this.module = this.fetchModule.data;
        } else {
          this.module = null;
        }
      });
  });

  handleLoadUnit = action((moduleId, unitId) => {
    this.fetchUnit
      .fetch({
        url: `/modules/${moduleId}/units/${unitId}`,
      })
      .then(() => {
        if (this.fetchUnit.data) {
          this.unit = this.fetchUnit.data;
        } else {
          this.unit = null;
        }
      });
  });

  handleLoadMasteryTest = action((moduleId, masteryTestId) => {
    this.fetchMasteryTest
      .fetch({
        url: `/modules/${moduleId}/mastery-tests/${masteryTestId}`,
      })
      .then(() => {
        if (this.fetchMasteryTest.data) {
          this.masteryTest = this.fetchMasteryTest.data;
        } else {
          this.masteryTest = null;
        }
      });
  });
}

export default ContentCourseDetailService;
